<template>
  <section class="cinema-section">
    <div class="container">
      <div class="cinema-container">
          <img
            :src="require('@/assets/image/cinema-section/cinema.jpg')"
            alt="cinema"
            class="cinema">
          <img
            :src="require('@/assets/image/cinema-section/screen.png')"
            alt="screen"
            class="screen">
        </div>
      <div class="cinema-text-container" id="cinemaText">
        <img
          :src="require('@/assets/image/cinema-section/screen.png')"
          alt="screen"
          class="screen-text">
        <div class="about">
          <div class="about__heading">
            <span>№10</span> Новинки кино стали ближе
          </div>
          <div class="about__text" id="firstCinemaText">
            Кинопремьеры переходят в online! Долгожданные новинки,
            среди которых «Матрица 4», «Чудо-Женщина: 1984»,
            «Лига справедливости» от Зака Снайдера и многие другие
            анонсированы к выходу в онлайне в день старта
            мирового проката <br><br>
            Уникальные фильмы и сериалы собственного
            производства появятся и в МТС ТВ в 2021 году.
            Дарим доступ в МТС ТВ по промокоду:  <strong>PODAROKTV</strong>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'v-cinema-section',
  mounted() {
    const timelineCinema = gsap.timeline({
      scrollTrigger: {
        trigger: '.cinema-section',
        start: '-=20%',
        end: 'bottom',
        scrub: 2,
        onToggle: (self) => console.log('toggled, isActive:', self.isActive),
        onUpdate: (self) => {
          console.log('progress2:', self.progress);
          const cinemaText = document.getElementById('cinemaText');
          const firstCinemaText = document.getElementById('firstCinemaText');
          if (self.progress > 0.25) {
            if (cinemaText.classList.contains('active')) {
              if (self.progress < 0.5 && !firstCinemaText.classList.contains('active')) {
                return;
              }
              if (self.progress < 0.5 && self.direction === -1) {
                firstCinemaText.classList.remove('active');
                TweenMax.to('#firstCinemaText', {
                  opacity: 1,
                });
                TweenMax.to('.screen-text', {
                  duration: 1,
                  scale: 1,
                  y: '-60px',
                });
                return;
              }
              firstCinemaText.classList.add('active');
              TweenMax.to('.screen-text', {
                duration: 1,
                scale: 1.2,
                y: '-60px',
              });
              return;
            }
            cinemaText.classList.add('active');
            document.body.style.background = '#F4F4F4';
            TweenMax.to('.cinema-container', {
              opacity: 0,
            });
            TweenMax.to('.cinema', {
              position: 'absolute',
            });
            TweenMax.to('.screen-text', {
              duration: 1,
              opacity: 1,
              scale: 1,
              y: '-60px',
            });
            TweenMax.fromTo('.cinema-text-container .about', {
              duration: 0,
              opacity: 0,
              y: '100px',
            }, {
              duration: 1,
              opacity: 1,
              y: 0,
            });
          } else {
            cinemaText.classList.remove('active');
            firstCinemaText.classList.remove('active');
            document.body.style.background = '#1D1D1D';
            TweenMax.to('.cinema-container', {
              opacity: 1,
            });
            TweenMax.to('.cinema', {
              position: 'relative',
            });
            TweenMax.to('.screen-text', {
              duration: 0,
              opacity: 0,
              y: '0px',
            });
            TweenMax.to('.cinema-text-container .about', {
              duration: 0,
              opacity: 0,
            });
            TweenMax.to('#firstCinemaText', {
              opacity: 1,
            });
          }
        },
      },
    });
    const timelineScreen = gsap.timeline({
      scrollTrigger: {
        trigger: '.cinema-section',
        start: '0%',
        end: 'bottom',
        scrub: 1,
      },
    });
    timelineCinema.addLabel('start')
      .to('.cinema', {
        duration: 1,
        opacity: 1,
        scale: 1.4,
      })
      .from('.screen', {
        opacity: 0.3,
        scale: 0.8,
      }, '-=1')
      .to('.screen', {
        duration: 1,
        y: '-60px',
      }, '-=1');
    timelineScreen.addLabel('start');
  },
};
</script>

<style lang="scss">
.cinema-section{
  min-height: calc(var(--vh)*150);
  position: relative;

  .container{
    //height: 100%;
    position: sticky;
    top: 20px;
    display: block;
    height: calc(var(--vh)*100);
  }
  .cinema-text-container{
    overflow: hidden;
    margin: 0 -15px;
  }
  .about{
    min-height: 340px;
    padding: 0 15px;
    opacity: 0;
  }
}
.cinema-container {
  //height: 0;
  margin: 0 -15px;
  position: relative;
  overflow: hidden;
  max-width: calc(100% + 30px);
}
.cinema{
  width: 100%;
  position: relative;
  display: block;
  top: 0;
  left: 0;
}
.screen{
  position: absolute;
  top: 43px;
  width: 100%;
}

.cinema-text-container{
  //position: sticky;
  //top: 20px;
}

.screen-text{
  position: relative;
  width: 100%;
  opacity: 0;
  margin-bottom: -30px;
  margin-top: 60px;
}
</style>
